import React from 'react';
import { ItemToReturn } from '@src/models/returns';
import { useReturnStore } from '@src/stores/returnStore';
import { useShipmentSeparation } from '@src/hooks/useShipmentSeparation';
import { SHIPMENT_TO_RETURN_METHOD_MAP } from '../../constants/general';
import { ReturnDetailCard } from './ReturnDetailCard';
import { LORPGroupedReturnDetailCard } from './LORPGroupedReturnDetailCard';

interface ReturnMethodCardsProps {
  onEditItemSubmit: (
    startingState: ItemToReturn,
    closeDrawer: () => void,
  ) => void;
  onRemoveItemSubmit: (selectedItemId: string) => void;
  isPolicyValidatorLoading: boolean;
  showLorpCheckboxError: boolean;
}

export const ReturnMethodCards: React.FC<ReturnMethodCardsProps> = ({
  onEditItemSubmit,
  onRemoveItemSubmit,
  isPolicyValidatorLoading,
  showLorpCheckboxError,
}) => {
  const selectedItems = useReturnStore((state) => state.selectedItems);
  const returnShipments = useReturnStore((state) => state.returnShipments);
  const { lorpShipments, sortedNonLorpReturnShipments } =
    useShipmentSeparation(returnShipments);
  return (
    <>
      {sortedNonLorpReturnShipments?.map((shipment) => {
        const returnMethod =
          SHIPMENT_TO_RETURN_METHOD_MAP[
            shipment.shipmentType as keyof typeof SHIPMENT_TO_RETURN_METHOD_MAP
          ];
        const policyValidatorLineItems = shipment.lineItems || [];
        // Use lineItemId from policy validator to get same line items from selectedItems
        const shipmentLineItems = selectedItems.filter((selectedItem) =>
          policyValidatorLineItems.some(
            (policyItem: { lineItemId: string }) =>
              policyItem.lineItemId === selectedItem.lineItemId,
          ),
        );

        return (
          <ReturnDetailCard
            key={shipment.shipmentId}
            method={returnMethod}
            shipmentLineItems={shipmentLineItems}
            shipment={shipment}
            onEditItemSubmit={onEditItemSubmit}
            onRemoveItemSubmit={onRemoveItemSubmit}
            isPolicyValidatorLoading={isPolicyValidatorLoading}
          />
        );
      })}
      {lorpShipments && lorpShipments.length > 0 && (
        <LORPGroupedReturnDetailCard
          lorpShipments={lorpShipments}
          onEditItemSubmit={onEditItemSubmit}
          onRemoveItemSubmit={onRemoveItemSubmit}
          isPolicyValidatorLoading={isPolicyValidatorLoading}
          showLorpCheckboxError={showLorpCheckboxError}
        />
      )}
    </>
  );
};
